import { isDMM } from './dmm';

/**
 * Base url for news on wordpress.
 */
const NEWS_BASE = 'https://news.riseoferos.com';
/**
 * Base dmm url for news on wordpress.
 */
const NEWS_BASE_DMM = 'https://dmg.news.riseoferos.com';

/**
 * Category of each language.
 * - id: `categories` params for posts filter.
 * - path: lang path for category
 * @see https://news.riseoferos.com/wp-json/wp/v2/categories
 */
const NEWS_CATEGORY: Record<string, { id: string; path: string; }> = {
  'en': { id: '16', path: '/en' },
  'ja': { id: '12', path: '/ja' },
  'ko': { id: '20', path: '/ko' },
  'zh-cn': { id: '8', path: '/zh-cn' },
  'zh-tw': { id: '1', path: '/' },
};

/**
 * Category number of each language.
 * - id: `categories` params for posts filter.
 * - path: lang path for category
 * @see https://dmg.news.riseoferos.com/wp-json/wp/v2/categories
 */
const NEWS_CATEGORY_DMM: Record<string, { id: string; path: string; }> = {
  'ja': { id: '1', path: '/' },
};

export const getNewsUrl = (language: string) => {
  const url = new URL(isDMM ? NEWS_BASE_DMM : NEWS_BASE);

  if (!isDMM) {
    url.pathname = NEWS_CATEGORY[language].path;
  }

  return url.toString();
};

export type NewsFields = {
  id: number;
  date_gmt: string;
  title: { rendered: string },
  jetpack_featured_media_url: string;
  jetpack_shortlink: string;
}

export const getNewsList = (language: string) => {
  const url = new URL(
    '/wp-json/wp/v2/posts',
    isDMM ? NEWS_BASE_DMM : NEWS_BASE
  );

  const params = Object.entries({
    per_page: '12',
    _fields: 'id,date_gmt,title,jetpack_featured_media_url,jetpack_shortlink',
    categories: isDMM ? NEWS_CATEGORY_DMM[language].id : NEWS_CATEGORY[language].id,
  });

  url.search = new URLSearchParams(params).toString();

  return url.toString();
}
